import { useLocalStorageState } from "hooks/useLocalStorageState";
import { z } from "zod";

const MAX_SAVED_RECIPES = 100;
const progressSchema = z.record(z.string(), z.array(z.number()));

export interface ChargeProgress {
  completedBasketNumbers: number[];
  setCompleted: (basketNumber: number, completed: boolean) => void;
}

export const useHeatChargeProgress = ({
  tenantName,
  stableHeatId,
  mixId,
}: {
  tenantName: string;
  stableHeatId: string | null;
  mixId: number | null;
}): ChargeProgress | undefined => {
  const [progress, setProgress] = useLocalStorageState<
    z.infer<typeof progressSchema>
  >("craneHeatChargeProgress", {}, { schema: progressSchema });

  if (stableHeatId === null || mixId === null) return undefined;

  const key = JSON.stringify([tenantName, stableHeatId, mixId]);
  return {
    completedBasketNumbers: progress[key] ?? [],
    setCompleted: (basketNumber, completed) => {
      setProgress((previous) => {
        const completedBasketNumbers = new Set(previous[key] ?? []);
        if (completed) {
          completedBasketNumbers.add(basketNumber);
        } else {
          completedBasketNumbers.delete(basketNumber);
        }
        const retained = Object.fromEntries(
          Object.entries(previous)
            .filter(([savedKey]) => savedKey !== key)
            .slice(-(MAX_SAVED_RECIPES - 1))
        );
        return { ...retained, [key]: [...completedBasketNumbers] };
      });
    },
  };
};
